import React from 'react'
import * as Styles from './SearchHistory.style'
import globalBus from '@/services/Bus'
import {Context} from '../HomeSearchPage'
import { withRouter, RouterProps } from 'react-router'

interface IsearchHistoryType {
    name: string
    type: string
    url: string
}

export const SearchHistory = withRouter((props: RouterProps) => {
    const serachContext = React.useContext(Context)

    React.useEffect(() => {
        serachContext.dispatch({
            type: 'GET_SEARCH_HISTORY',
            payload: {}
        })
    }, [])

    // 删除历史记录
    const deleteHistory = () => {
        globalBus.emit({
            dialogInfo: {
                isShow: true,
                ButtonStyle: ['warnBtn', 'cancelBtn'],
                title: '确定清除历史搜索记录吗？',
                subTitle: '',
                fn: [
                    {tag: 'cancel', name: '取消', fn: () => {
                        globalBus.emit({ dialogInfo: {isShow: false}})
                    }},
                    {tag: 'success', name: '清除', fn: () => {
                        globalBus.emit({ dialogInfo: {isShow: false}})
                        serachContext.dispatch({
                            type: 'DELETE_SEARCH_HISTORY',
                            payload: {}
                        })
                    }}
                ]
            }
        })
    }

    // 切割文字
    const sliceText = (text: string) => {
        let newStr = ''
        if (text.length > 8) {
            newStr = text.slice(0, 8) + '...'
            return newStr
        } else {
            return text
        }
    }

    const link = (name: string, url: string, ItemType: string) => {
        if (ItemType === 'special') {
            serachContext.dispatch({
                type: 'SET_SEARCH_HISTORY',
                payload: {value: name, ItemType: 'special', url}
            })
            setTimeout(() => {
                window.location.assign(url)
            }, 0)
        } else {
            let keyword = url
            try {
                keyword = encodeURIComponent(url)
            } catch (error) {
                keyword = url
            }
            serachContext.dispatch({
                type: 'SET_SEARCH_HISTORY',
                payload: {value: name, ItemType, url}
            })
            setTimeout(() => {
                try {
                    props.history.push(`/search-result?keyword=${keyword}`)
                } catch (error) {
                    props.history.push(`/search-result?keyword=${keyword}`)
                }

            }, 0)
        }
    }

    if (serachContext.state.value && serachContext.state.value.length > 0) {

        return (
            <div className={Styles.searchHistory}>
                <div className={Styles.searchHistoryTitleWrap}>
                    <div className={Styles.searchHistoryTitle}>
                        <p>搜索历史</p>
                    </div>
                    <div className={Styles.deleteHistory} onClick={() => deleteHistory()}>
                        <img src="https://static-1253442168.image.myqcloud.com/picture/11285307_b17332daec8fdc56ae54981a0018afa2.jpg" alt=""/>
                    </div>
                </div>
                <div className={Styles.searchHistoryList}>
                    <div className={Styles.searchHistoryListWrap}>
                        <ul>
                            {(serachContext.state.value).map((item: IsearchHistoryType) => (
                                <li onClick={() => {link(item.name, item.url, item.type)}} className={Styles.searchHistoryListItem} key={item.name}>{sliceText(item.name)}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            )
    } else {
        return null
    }
}
)



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/SearchHistory/SearchHistory.tsx